import { EventEmitter } from '@angular/core';
import { ClientErrorCodes } from '@models';
import { isHtml, isJson, } from '@utils/string.utils';
import cloneDeep from 'lodash-es/cloneDeep';
import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
// tslint:disable-next-line:max-line-length
var dateRegex = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;
// tslint:disable-next-line:max-line-length
var isoDateRegex = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;
var isStringUTCDate = function (str) {
    return typeof str === 'string' &&
        !isJson(str) &&
        (dateRegex.test(str) ||
            isoDateRegex.test(str)) &&
        moment(str).isValid();
};
var ɵ0 = isStringUTCDate;
export var compareObjects = function (a, b) {
    if (a === b) {
        return true;
    }
    if (a === null || b === null) {
        return false;
    }
    if (a instanceof Array && b instanceof Array) {
        if (a.length !== b.length) {
            return false;
        }
        var areEqual = true;
        for (var i = 0; i < a.length; i++) {
            areEqual = areEqual && compareObjects(a[i], b[i]);
        }
        return areEqual;
    }
    if (a instanceof Object && b instanceof Object) {
        var keys_1 = new Set();
        Object.keys(a).forEach(function (key) { return keys_1.add(key); });
        Object.keys(b).forEach(function (key) { return keys_1.add(key); });
        if (keys_1.size === 0) {
            return true;
        }
        var areEqual_1 = true;
        keys_1.forEach(function (key) {
            if (a.hasOwnProperty(key) && b.hasOwnProperty(key)) {
                areEqual_1 = areEqual_1 && compareObjects(a[key], b[key]);
            }
            else {
                areEqual_1 = false;
            }
        });
        return areEqual_1;
    }
    return a === b;
};
export function getProperty(object, propertyChain, translatePrefix) {
    if (translatePrefix === void 0) { translatePrefix = ''; }
    var chain = propertyChain.split('.');
    var value = object;
    chain.forEach(function (prop) {
        if (value == null) {
            return value;
        }
        value = value[prop];
    });
    return value != null && typeof value === 'string' ? translatePrefix + value : value;
}
export function extractErrorMessage(error, defaultMessage) {
    if (defaultMessage === void 0) { defaultMessage = "An unexpected error has occured (#" + ClientErrorCodes.GenericError + ")"; }
    var errorBody = getProperty(error, 'error.error') ||
        getProperty(error, 'error') ||
        error;
    var errorCode = errorBody.errorCode || (errorBody.error ? errorBody.error.code : errorBody.code);
    var message;
    if (typeof errorBody === 'object') {
        if (errorBody.innererror) {
            // ABP exceptions
            message = errorBody.innererror.message.replace('[', '').replace(']', '');
        }
        else {
            // other services exceptions
            message = errorBody.message;
        }
    }
    else if (isHtml(errorBody) || typeof errorBody !== 'string') {
        message = defaultMessage;
    }
    else {
        message = errorBody;
    }
    return errorCode == null ? message : message + " (#" + errorCode + ")";
}
export function toDate(obj) {
    if (obj == null) {
        return obj;
    }
    if (obj instanceof Array) {
        return obj.map(function (entry) { return toDate(entry); });
    }
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (isArray(obj[key])) {
            obj[key] = obj[key]
                .map(function (subEntry) { return isStringUTCDate(subEntry) ?
                moment(subEntry).toDate() :
                toDate(subEntry); });
            continue;
        }
        if (isObject(obj[key])) {
            obj[key] = toDate(obj[key]);
            continue;
        }
        var checkedString = obj[key];
        if (!key.endsWith('Str') &&
            isStringUTCDate(checkedString)) {
            obj[key] = moment(checkedString)
                .toDate();
        }
    }
    return obj;
}
export function serializeMomentInstance(date) {
    var isoString = date.toISOString();
    return isoString.substr(0, isoString.length - 5) + "Z";
}
export function serializeDates(obj) {
    // serialize Date and Moment instances into ISO String without sub-second precision
    if (obj == null) {
        return obj;
    }
    if (moment.isMoment(obj)) {
        return serializeMomentInstance(obj);
    }
    if (obj instanceof Date) {
        return serializeMomentInstance(moment(obj));
    }
    if (obj instanceof Array) {
        return obj.map(function (entry) { return serializeDates(entry); });
    }
    var objClone = cloneDeep(obj);
    for (var _i = 0, _a = Object.keys(objClone); _i < _a.length; _i++) {
        var key = _a[_i];
        if (isArray(objClone[key])) {
            objClone[key] = objClone[key]
                .map(function (subEntry) { return serializeDates(subEntry); });
            continue;
        }
        if (isObject(objClone[key])) {
            objClone[key] = serializeDates(objClone[key]);
            continue;
        }
    }
    return objClone;
}
export function unsubscribe() {
    var subscriptions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        subscriptions[_i] = arguments[_i];
    }
    subscriptions.forEach(function (subscription) {
        if ((subscription instanceof Subscription ||
            subscription instanceof EventEmitter) &&
            !subscription.closed) {
            subscription.unsubscribe();
        }
    });
}
export var safeParse = function (obj, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (obj == null) {
        return defaultValue;
    }
    try {
        return JSON.parse(obj);
    }
    catch (_a) {
        return defaultValue;
    }
};
export var safeTrim = function (obj) { return typeof obj === 'string' ? obj.trim() : obj; };
export var addToArrayIf = function (condition) {
    var elements = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        elements[_i - 1] = arguments[_i];
    }
    return condition ? elements : [];
};
export var addToObjectIf = function (condition, element) {
    return condition ? element : {};
};
export var pick = function (obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var ret = {};
    keys.forEach(function (key) {
        ret[key] = obj[key];
    });
    return ret;
};
export { ɵ0 };
